import PropTypes from "prop-types";

import { ptsCss, ptsLabelCss, svgCss } from "./PowerWordsScoreGraphic.style";
import { ScoreGraphic } from "./ScoreGraphic";

const propTypes = {
  powerWordsPoints: PropTypes.number,
  isSubmitted: PropTypes.bool,
  currentItem: PropTypes.number,
};

const getCorrectValueForScore = (
  powerWordsPoints,
  isSubmitted,
  currentItem,
) => {
  // If first question is answered incorrectly score should be updated from '-' to integer zero
  if (!powerWordsPoints && !isSubmitted && parseInt(currentItem) === 1) {
    return "-";
  }

  return powerWordsPoints;
};

const SvgText = ({ powerWordsPoints, isSubmitted, currentItem }) => {
  // Font size needs to be decreased if there is a 2-digit number
  const isTwoDigitNumber = powerWordsPoints >= 10;
  const scoreValue = getCorrectValueForScore(
    powerWordsPoints,
    isSubmitted,
    currentItem,
  );
  const scoreCharIsNumber = typeof scoreValue === "number";

  return (
    <text x="25" y="15">
      <tspan
        aria-hidden="true"
        css={ptsCss(isTwoDigitNumber)}
        dx={scoreCharIsNumber ? ".55em" : ".66em"}
        dy={isTwoDigitNumber ? "45%" : "50%"}
      >
        {scoreValue}
      </tspan>
      <tspan aria-hidden="true" css={ptsLabelCss} dx=".25em">
        {powerWordsPoints === 1 ? "pt" : "pts"}
      </tspan>
    </text>
  );
};

const PowerWordsScoreGraphics = ({
  powerWordsPoints,
  isSubmitted,
  currentItem,
}) => {
  const powerWordsPointsText = `${powerWordsPoints} ${powerWordsPoints === 1 ? "point" : "points"}`;
  return (
    <ScoreGraphic __cssFor={svgCss} powerWordsPointsText={powerWordsPointsText}>
      <SvgText
        powerWordsPoints={powerWordsPoints}
        currentItem={currentItem}
        isSubmitted={isSubmitted}
      />
    </ScoreGraphic>
  );
};

PowerWordsScoreGraphics.propTypes = propTypes;
SvgText.propTypes = propTypes;
export default PowerWordsScoreGraphics;
